import { render } from "./AppFooterMobile.vue?vue&type=template&id=153c0034&scoped=true"
import script from "./AppFooterMobile.vue?vue&type=script&lang=js"
export * from "./AppFooterMobile.vue?vue&type=script&lang=js"

import "./AppFooterMobile.vue?vue&type=style&index=0&id=153c0034&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153c0034"]])

export default __exports__